import { BehaviorSubject, Observable } from "rxjs";
import * as Cookie from "js-cookie";
import { LOGIN_SSO_WAITING_PAGE } from "config/route-consts";
import { profileRepository } from "repositories/profile-repository";
import { Repository } from "react3l-common";
import { externalAuthenticationRepository } from "repositories/external-authentication-repository";

class AuthenticationService extends Repository {
  public currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  constructor() {
    super();
    const currentUserInfo = localStorage.getItem("currentUserInfo");
    this.currentUserSubject = new BehaviorSubject<any>(
      currentUserInfo ? JSON.parse(currentUserInfo) : null
    );
    this.currentUser = this.currentUserSubject.asObservable();
    if (this.currentUserSubject.value && this.currentUserSubject.value.token) {
      Cookie.set("access_token", this.currentUserSubject.value.token, {
        domain: `${process.env.REACT_APP_URI_COOKIE}`,
      });
    }
  }

  public login(loginInfo: any) {
    const loginPromise = new Promise((resolve, reject) => {
      //Fake login:
      // localStorage.setItem("currentUserInfo", JSON.stringify(loginInfo));
      // Cookie.set("Token", "a6e0459b-9f50-42f8-b9d0-20cc9b4ce225");
      // this.currentUserSubject.next(loginInfo);
      // resolve(loginInfo);

      //Real login
      // profileRepository.login(loginInfo).subscribe(
      //   (res: any) => {
      //     if (res) {
      //       localStorage.setItem("currentUserInfo", JSON.stringify(res));
      //       Cookie.set("access_token", res.accessToken, { domain: `${process.env.REACT_APP_URI_COOKIE}`});
      //       Cookie.set("refreshToken", res.refreshToken, { domain: `${process.env.REACT_APP_URI_COOKIE}`});
      //       this.currentUserSubject.next(res);
      //       resolve(res);
      //     }
      //   },
      //   (err) => {
      //     reject(err);
      //   }
      // );
      externalAuthenticationRepository
        .getEndpoint(
          `${window.location.protocol}//${window.location.host}${process.env.REACT_APP_PREFIX_URL}/login-sso-waiting-page`
        )
        .subscribe((res: String) => {
          return window.open(res.toString(), "_self");
        });
    });
    return loginPromise;
  }

  public listPath() {
    return this.http
      .post<any>(`/rpc/portal/permission/list-path`, {})
      .pipe(Repository.responseDataMapper<any>());
  }

  public logout() {
    externalAuthenticationRepository.logout().subscribe((res: boolean) => {
      if (res) {
        localStorage.removeItem("currentUserInfo");
        Cookie.remove("Token", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        Cookie.remove("access_token", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        Cookie.remove("refreshToken", {
          domain: `${process.env.REACT_APP_URI_COOKIE}`,
        });
        const kcUri = `${process.env.REACT_APP_KEYCLOAK_URL}/auth?response_type=code&client_id=emp-con-app&redirect_uri=${process.env.REACT_APP_DOMAIN}${LOGIN_SSO_WAITING_PAGE}`;        window.open(`${kcUri}`, "_self");
        this.currentUserSubject.next(null);
      }
    });
  }

  public getSwitchAccountCode() {
    const currentPromise = new Promise((resolve, reject) => {
      profileRepository.getSwitchAccountCode().subscribe(
        (res: any) => {
          if (res) {
            resolve(res);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
    return currentPromise;
  }

  public switchAccount(code: string) {
    const currentPromise = new Promise((resolve, reject) => {
      profileRepository.switchAccount(code).subscribe(
        (res: any) => {
          if (res) {
            resolve(res);
          }
        },
        (err) => {
          reject(err);
        }
      );
    });
    return currentPromise;
  }
}

export default new AuthenticationService();
